try {
    $("#menu-toggle-open").click(function () {
        $("#nav--mb--menu").toggleClass("nav--mb--menu--show");
        $("#bg-mb").toggleClass("bg-mb--show");
    });
} catch (error) {
    console.error(error);
}

try {
    $("#bg-mb").click(function () {
        $("#nav--mb--menu").toggleClass("nav--mb--menu--show");
        $("#bg-mb").toggleClass("bg-mb--show");
    });
} catch (error) {
    console.error(error);
}

try {
    $("#menu-toggle-close").click(function () {
        $("#nav--mb--menu").toggleClass("nav--mb--menu--show");
        $("#bg-mb").toggleClass("bg-mb--show");
    });
} catch (error) {
    console.error(error);
}

try {
    $(".nav--mb--menu__body__label").click(function () {
        var findClass = ($(this).attr('class').split(' ')[1]);
        var findClassSel = $("." + findClass);

        setTimeout(function () {
            var heightMenu = $('.nav--mb--menu__body').height();
            $(".menu-fold").css("height", ("calc(100vh - " + (heightMenu + 130) + "px)"));
        }, 400);

        findClassSel.last().toggleClass("nav--mb--menu__body__list--show");
        findClassSel.first().find(".path").toggleClass("path--hide");

        $(".nav--mb--menu__body__list").not("." + findClass).removeClass("nav--mb--menu__body__list--show");
        $(".nav--mb--menu__body__label").not("." + findClass).find(".path").removeClass("path--hide");
    });
} catch (error) {
    console.error(error);
}

try {
    $(".menu-fold").click(function () {
        $(".nav--mb--menu__body__list").removeClass("nav--mb--menu__body__list--show");
        $(".nav--mb--menu__body__label").removeClass("path--hide");
    });
} catch (error) {
    console.error(error);
}

try {
    $('#search-toggle').click(function () {
        if ($('#search').val().length === 0) {
            $("#search-toggle").attr("type", "reset");
            $('.search').toggleClass('search-input--show');
            $('.menu-mb').toggleClass('menu-mb--hide');
            $('.search-form-mb-close').toggleClass('search-form-mb-close--show');

            setTimeout(function () {
                $("#search").filter(':visible').focus();
            }, 500);

        } else if ($('#search').val().length > 0) {
            $("#search-toggle").attr("type", "submit");
        }
    });
} catch (error) {
    console.error(error);
}

try {
    $('#search-form-mb-close').click(function () {
        $("#search-toggle").attr("type", "reset");
        $('.search').removeClass('search-input--show');
        $('.menu-mb').removeClass('menu-mb--hide');
        $('.search-form-mb-close').removeClass('search-form-mb-close--show');
    });
} catch (error) {
    console.error(error);
}

try {
    $('#search-toggle-desktop').click(function () {
        if ($('#search-desktop').val().length === 0) {
            $("#search-toggle-desktop").attr("type", "reset");
            $('.search-desktop').toggleClass('search-desktop-input--show');
            $('.search-form-desktop').toggleClass('search-form-desktop--show');
            $('.search-form-desktop-close').toggleClass('search-form-desktop-close--show');
            $('.bg-dsktp').toggleClass('bg-dsktp--show');

            setTimeout(function () {
                $("#search-desktop").filter(':visible').focus();
            }, 500);

        } else if ($('#search-desktop').val().length > 0) {
            $("#search-toggle-desktop").attr("type", "submit");
        }
    });
} catch (error) {
    console.error(error);
}

try {
    $('#search-form-desktop-close').click(function () {
        $('.search-desktop').removeClass('search-desktop-input--show');
        $('.search-form-desktop').removeClass('search-form-desktop--show');
        $('.search-form-desktop-close').removeClass('search-form-desktop-close--show');
        $('.bg-dsktp').removeClass('bg-dsktp--show');
    });
} catch (error) {
    console.error(error);
}

try {
    $('#bg-dsktp').click(function () {
        $('.search-desktop').removeClass('search-desktop-input--show');
        $('.search-form-desktop').removeClass('search-form-desktop--show');
        $('.search-form-desktop-close').removeClass('search-form-desktop-close--show');
        $('.bg-dsktp').removeClass('bg-dsktp--show');
    });
} catch (error) {
    console.error(error);
}
